import _asyncToGenerator from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var _marked = /*#__PURE__*/_regeneratorRuntime().mark(U);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e3) { throw _e3; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e4) { didErr = true; err = _e4; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { cloneDeep as e, get as t, set as r, has as n, setWith as o, trimStart as i } from "lodash";
import { isAbsolute as a, join as s, dirname as c } from "@stoplight/path";
import { createScanner as u, findNodeAtOffset as l, getNodePath as f, visit as p, printParseErrorCode as h } from "jsonc-parser";
import y, { getOrder as g, ORDER_KEY_ID as d } from "@stoplight/ordered-object-literal";
import { DiagnosticSeverity as v } from "@stoplight/types";
import m from "safe-stable-stringify";

function b(e) {
  if ("object" != typeof e || null === e) return !1;
  var t = Object.getPrototypeOf(e);
  return null === t || t === Object.prototype || "function" == typeof e.constructor && Function.toString.call(Object) === Function.toString.call(e.constructor);
}

function w(e, t, r) {
  if (!b(e) && !Array.isArray(e) || !(t in e)) throw new ReferenceError("Could not resolve '".concat(r, "'"));
}

function O(e) {
  if ("string" != typeof e.$ref) throw new TypeError("$ref should be a string");
}

var j = function j(e) {
  return b(e) && "$ref" in e;
},
    A = function A(e) {
  return j(e) && "string" == typeof e.$ref;
},
    E = function E(e) {
  return e.length > 0 && ("#" === e || /^#\S*$/.test(e));
},
    S = function S(e, t, r) {
  var n = e.toString();
  var o = "",
      i = n,
      a = 0,
      s = i.indexOf(t);

  for (; s > -1;) {
    o += n.substring(a, a + s) + r, i = i.substring(s + t.length, i.length), a += s + t.length, s = i.indexOf(t);
  }

  return i.length > 0 && (o += n.substring(n.length - i.length, n.length)), o;
},
    $ = function $(e) {
  return "number" == typeof e ? e : S(S(e, "~", "~0"), "/", "~1");
},
    x = function x(e) {
  return _(e);
},
    _ = function _(e) {
  if (e && "object" != typeof e) throw new TypeError("Invalid type: path must be an array of segments.");
  return 0 === e.length ? "#" : "#/".concat(e.map($).join("/"));
};

function k(e) {
  try {
    return decodeURIComponent(e);
  } catch (t) {
    return e;
  }
}

var N = /%[0-9a-f]+/gi,
    P = function P(e) {
  var t;

  try {
    t = decodeURIComponent(e);
  } catch (r) {
    t = e.replace(N, k);
  }

  return S(S(t, "~1", "/"), "~0", "~");
},
    T = function T(e) {
  return I(e);
},
    I = function I(e) {
  if ("string" != typeof e) throw new TypeError("Invalid type: JSON Pointers are represented as strings.");
  if (0 === e.length || "#" !== e[0]) throw new URIError("Invalid JSON Pointer syntax; URI fragment identifiers must begin with a hash.");
  if (1 === e.length) return [];
  if ("/" !== e[1]) throw new URIError("Invalid JSON Pointer syntax.");
  return function (e) {
    var t = e.length,
        r = [];
    var n = -1;

    for (; ++n < t;) {
      r.push(P(e[n]));
    }

    return r;
  }(e.substring(2).split("/"));
},
    R = function R(e) {
  if ("string" != typeof e || 0 === e.length || E(e)) return null;
  var t = e.indexOf("#");
  return -1 === t ? e : e.slice(0, t);
};

function K(e, t) {
  return b(t) && b(e) && ("summary" in e || "description" in e) ? Object.assign(Object.assign(Object.assign({}, t), "description" in e ? {
    description: e.description
  } : null), "summary" in e ? {
    summary: e.summary
  } : null) : t;
}

function U(e, t, r) {
  var _iterator, _step, _step$value, _n, _o;

  return _regeneratorRuntime().wrap(function U$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.t0 = j(e.value);

          if (!_context.t0) {
            _context.next = 5;
            break;
          }

          O(e.value);
          _context.next = 5;
          return [-1, e.value];

        case 5:
          _iterator = _createForOfIteratorHelper(t.entries());
          _context.prev = 6;

          _iterator.s();

        case 8:
          if ((_step = _iterator.n()).done) {
            _context.next = 19;
            break;
          }

          _step$value = _slicedToArray(_step.value, 2), _n = _step$value[0], _o = _step$value[1];
          w(e.value, _o, r);
          e.value = e.value[_o];
          _context.t1 = j(e.value);

          if (!_context.t1) {
            _context.next = 17;
            break;
          }

          O(e.value);
          _context.next = 17;
          return [_n, e.value];

        case 17:
          _context.next = 8;
          break;

        case 19:
          _context.next = 24;
          break;

        case 21:
          _context.prev = 21;
          _context.t2 = _context["catch"](6);

          _iterator.e(_context.t2);

        case 24:
          _context.prev = 24;

          _iterator.f();

          return _context.finish(24);

        case 27:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[6, 21, 24, 27]]);
}

function M(e, t) {
  return C(e, t).value;
}

function C(e, t) {
  return function e(t, r, n, o) {
    if (null !== R(r)) throw new ReferenceError("Cannot resolve external references");
    var i = T(r);

    var a = _toConsumableArray(i);

    "#" === r && j(t) && (O(t), i.unshift.apply(i, _toConsumableArray(T(t.$ref))));
    var s = {
      value: t
    };

    var _iterator2 = _createForOfIteratorHelper(U(s, i, r)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _a;

        var _step2$value = _slicedToArray(_step2.value, 2),
            _c = _step2$value[0],
            _u = _step2$value[1];

        if (n.includes(_u)) return {
          source: null,
          location: null != o ? o : a,
          value: n[n.length - 1]
        };
        n.push(_u);

        var _r = e(t, _u.$ref, n, a);

        s.value = _r.value, (_a = a = _r.location).push.apply(_a, _toConsumableArray(i.slice(_c + 1)));
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return {
      source: null,
      location: a,
      value: n.length > 0 ? K(n[n.length - 1], s.value) : s.value
    };
  }(e, t, []);
}

var D = function D(e, t, r) {
  var n = {
    value: e,
    path: r
  };
  t.onEnter && t.onEnter(n);

  for (var _i = 0, _Object$keys = Object.keys(e); _i < _Object$keys.length; _i++) {
    var _n2 = _Object$keys[_i];
    var _o2 = e[_n2];
    t.onProperty && t.onProperty({
      parent: e,
      parentPath: r,
      property: _n2,
      propertyValue: _o2
    }), "object" == typeof _o2 && null !== _o2 && D(_o2, t, r.concat(_n2));
  }

  t.onLeave && t.onLeave(n);
},
    J = function J(e, t) {
  "object" == typeof e && null !== e && D(e, "function" == typeof t ? {
    onProperty: t
  } : t, []);
},
    V = "#/__bundled__",
    F = "#/__errors__",
    L = function L(_ref, s) {
  var t = _ref.document,
      r = _ref.path,
      _ref$bundleRoot = _ref.bundleRoot,
      n = _ref$bundleRoot === void 0 ? "#/__bundled__" : _ref$bundleRoot,
      _ref$errorsRoot = _ref.errorsRoot,
      o = _ref$errorsRoot === void 0 ? "#/__errors__" : _ref$errorsRoot,
      _ref$cloneDocument = _ref.cloneDocument,
      i = _ref$cloneDocument === void 0 ? !0 : _ref$cloneDocument,
      a = _ref.keyProvider;
  if (r === n || r === o) throw new Error("Roots do not make any sense");
  var c = i ? e(t) : t;
  return W(c, T(n), T(o), a)(r, _defineProperty({}, r, !0), s);
},
    W = function W(e, i, a, s) {
  var c = new Set(),
      u = function u(l, f, p) {
    var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var y = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var g = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    var d = T(l),
        v = t(e, d);
    J(p || v, {
      onEnter: function onEnter(_ref2) {
        var a = _ref2.value;

        if (A(a) && E(a.$ref)) {
          var _p = a.$ref;
          if (g[_p]) return;
          if (_p === l && (h[_p] = "#"), h[_p]) return void (a.$ref = h[_p]);

          var _d, _v, _m, _b, _w;

          try {
            var _r2;

            _d = T(_p), s && (_r2 = s({
              document: e,
              path: _d
            })), _r2 || (_r2 = function (_ref3) {
              var e = _ref3.document,
                  r = _ref3.path;
              if (Array.isArray(t(e, r.slice(0, -1)))) return "".concat(r[r.length - 2], "_").concat(r[r.length - 1]);
              return String(r[r.length - 1]);
            }({
              document: e,
              path: _d
            })), _m = _r2;
            var _n3 = 1;

            for (; c.has(_m);) {
              if (_m = "".concat(_r2, "_").concat(++_n3), _n3 > 20) throw new Error("Keys ".concat(_r2, "_2 through ").concat(_r2, "_20 already taken."));
            }

            c.add(_m), _v = [].concat(_toConsumableArray(i), [_m]), _b = x(_v);
          } catch (e) {
            g[_p] = e instanceof Error ? e.message : String(e);
          }

          if (!_d || !_v || !_b) return;
          if ("object" == typeof e && null !== e && !(_w = t(e, _d))) try {
            _w = M(Object(e), _p);
          } catch (e) {}
          void 0 !== _w && (h[_p] = _b, a.$ref = _b, n(y, _v) || (Array.isArray(_w) ? r(y, _v, new Array(_w.length).fill(null)) : "object" == typeof _w && o(y, _v, {}, Object), r(y, _v, _w), f[_p] || (f[_p] = !0, u(l, f, _w, h, y, g), f[_p] = !1)));
        }
      }
    });
    var m = t(y, i);
    return m && Object.keys(m).length && r(v, i, m), (Object.keys(g).length || n(e, a)) && r(v, a, n(e, a) ? t(e, a) : g), v;
  };

  return u;
},
    B = function B(e) {
  return S(S(e, "~1", "/"), "~0", "~");
},
    q = function q(e, t) {
  var r = new WeakMap();
  return function e(n, o) {
    var i;

    if (t && (n = t(n)), b(n) || Array.isArray(n)) {
      var _t = r.get(n);

      return _t ? {
        $ref: _t
      } : (r.set(n, x(o)), Array.isArray(n) ? i = n.map(function (t, r) {
        return e(t, [].concat(_toConsumableArray(o), [String(r)]));
      }) : (i = {}, Object.keys(n).forEach(function (t) {
        i[t] = e(n[t], [].concat(_toConsumableArray(o), [t]));
      })), r.delete(n), i);
    }

    return n;
  }(e, []);
},
    z = function z(e) {
  return S(S(e, "~", "~0"), "//", "/~1");
},
    G = function G(e) {
  if ("string" != typeof e || 0 === e.length) return null;
  var t = e.indexOf("#");
  return -1 === t ? null : e.slice(t);
},
    H = function H(e) {
  var t = u(e, !0);
  if (t.scan(), 1 !== t.getToken()) return;
  if (t.scan(), 2 === t.getToken()) return;
  if (10 !== t.getToken()) throw new SyntaxError("Unexpected character");
  var r = t.getTokenValue();
  if (t.scan(), 6 !== t.getToken()) throw new SyntaxError("Colon expected");

  switch (t.scan(), t.getToken()) {
    case 10:
      return [r, t.getTokenValue()];

    case 11:
      return [r, Number(t.getTokenValue())];

    case 8:
      return [r, !0];

    case 9:
      return [r, !1];

    case 7:
      return [r, null];

    case 16:
      throw new SyntaxError("Unexpected character");

    case 17:
      throw new SyntaxError("Unexpected end of file");

    default:
      return;
  }
},
    Q = function Q(_ref4, r) {
  var e = _ref4.lineMap,
      t = _ref4.ast;
  var n = e[r.line],
      o = e[r.line + 1];
  if (void 0 === n) return;
  var i = l(t, void 0 === o ? n + r.character : Math.min(o, n + r.character), !0);
  if (void 0 === i) return;
  var a = f(i);
  return 0 !== a.length ? a : void 0;
};

function X(e) {
  return B(e.split("/").pop() || "");
}

var Y = function Y(_ref5, t) {
  var e = _ref5.ast;
  var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

  var n = function (e, t, r) {
    var _iterator3 = _createForOfIteratorHelper(t),
        _step3;

    try {
      e: for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _n4 = _step3.value;

        var _t2 = Number.isInteger(Number(_n4)) ? Number(_n4) : _n4;

        if ("string" == typeof _t2 || "number" == typeof _t2 && "array" !== e.type) {
          if ("object" !== e.type || !Array.isArray(e.children)) return r ? e : void 0;

          var _iterator4 = _createForOfIteratorHelper(e.children),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _r3 = _step4.value;

              if (Array.isArray(_r3.children) && _r3.children[0].value === String(_t2) && 2 === _r3.children.length) {
                e = _r3.children[1];
                continue e;
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          return r ? e : void 0;
        }

        if ("array" !== e.type || _t2 < 0 || !Array.isArray(e.children) || _t2 >= e.children.length) return r ? e : void 0;
        e = e.children[_t2];
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return e;
  }(e, t, r);

  if (void 0 !== n && void 0 !== n.range) return {
    range: n.range
  };
};

var Z = function Z(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    disallowComments: !0
  };

  var r = [],
      _ee = ee(e, r, t),
      n = _ee.ast,
      o = _ee.data,
      i = _ee.lineMap;

  return {
    data: o,
    diagnostics: r,
    ast: n,
    lineMap: i
  };
};

function ee(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var r = arguments.length > 2 ? arguments[2] : undefined;
  var n = re(e);
  var o = {
    type: "array",
    offset: -1,
    length: -1,
    children: [],
    parent: void 0
  },
      i = null,
      a = [];
  var s = new WeakMap(),
      c = [];

  function u(e) {
    "property" === o.type && (o.length = e - o.offset, o = o.parent);
  }

  function l(e, t, r) {
    return {
      start: {
        line: e,
        character: t
      },
      end: {
        line: e,
        character: t + r
      }
    };
  }

  function f(e) {
    return o.children.push(e), e;
  }

  function d(e) {
    Array.isArray(a) ? a.push(e) : null !== i && (a[i] = e);
  }

  function m(e) {
    d(e), c.push(a), a = e, i = null;
  }

  function b() {
    a = c.pop();
  }

  p(e, {
    onObjectBegin: function onObjectBegin(e, t, n, i) {
      o = f({
        type: "object",
        offset: e,
        length: -1,
        parent: o,
        children: [],
        range: l(n, i, t)
      }), !1 === r.ignoreDuplicateKeys && s.set(o, []), m(function (e) {
        return e ? y({}) : {};
      }(!0 === r.preserveKeyOrder));
    },
    onObjectProperty: function onObjectProperty(e, n, c, u, p) {
      if ((o = f({
        type: "property",
        offset: n,
        length: -1,
        parent: o,
        children: []
      })).children.push({
        type: "string",
        value: e,
        offset: n,
        length: c,
        parent: o
      }), !1 === r.ignoreDuplicateKeys) {
        var _r4 = s.get(o.parent);

        _r4 && (0 !== _r4.length && _r4.includes(e) ? t.push({
          range: l(u, p, c),
          message: "DuplicateKey",
          severity: v.Error,
          path: ne(o),
          code: 20
        }) : _r4.push(e));
      }

      !0 === r.preserveKeyOrder && function (e, t) {
        if (!(t in e)) return;
        var r = g(e),
            n = r.indexOf(t);
        -1 !== n && (r.splice(n, 1), r.push(t));
      }(a, e), i = e;
    },
    onObjectEnd: function onObjectEnd(e, t, n, i) {
      !1 === r.ignoreDuplicateKeys && s.delete(o), o.length = e + t - o.offset, o.range && (o.range.end.line = n, o.range.end.character = i + t), o = o.parent, u(e + t), b();
    },
    onArrayBegin: function onArrayBegin(e, t, r, n) {
      o = f({
        type: "array",
        offset: e,
        length: -1,
        parent: o,
        children: [],
        range: l(r, n, t)
      }), m([]);
    },
    onArrayEnd: function onArrayEnd(e, t, r, n) {
      o.length = e + t - o.offset, o.range && (o.range.end.line = r, o.range.end.character = n + t), o = o.parent, u(e + t), b();
    },
    onLiteralValue: function onLiteralValue(e, t, r, n, i) {
      f({
        type: te(e),
        offset: t,
        length: r,
        parent: o,
        value: e,
        range: l(n, i, r)
      }), u(t + r), d(e);
    },
    onSeparator: function onSeparator(e, t) {
      "property" === o.type && (":" === e ? o.colonOffset = t : "," === e && u(t));
    },
    onError: function onError(e, r, n, o, i) {
      t.push({
        range: l(o, i, n),
        message: h(e),
        severity: v.Error,
        code: e
      });
    }
  }, r);
  var w = o.children[0];
  return w && delete w.parent, {
    ast: w,
    data: a[0],
    lineMap: n
  };
}

function te(e) {
  switch (typeof e) {
    case "boolean":
      return "boolean";

    case "number":
      return "number";

    case "string":
      return "string";

    default:
      return "null";
  }
}

var re = function re(e) {
  var t = [0];
  var r = 0;

  for (; r < e.length; r++) {
    "\n" === e[r] && t.push(r + 1);
  }

  return t.push(r + 1), t;
};

function ne(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return "property" === e.type && t.unshift(e.children[0].value), void 0 !== e.parent ? ("array" === e.parent.type && void 0 !== e.parent.parent && t.unshift(e.parent.children.indexOf(e)), ne(e.parent, t)) : t;
}

var oe = function oe(e, t, r) {
  if (!e || !Object.hasOwnProperty.call(e, t) || t === r) return e;
  var n = {};

  for (var _i2 = 0, _Object$entries = Object.entries(e); _i2 < _Object$entries.length; _i2++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
        _o3 = _Object$entries$_i[0],
        _i3 = _Object$entries$_i[1];

    _o3 === t ? n[r] = _i3 : _o3 in n || (n[_o3] = _i3);
  }

  return n;
};

function ie(e) {
  return b(e) || Array.isArray(e);
}

function ae(e, t, r) {
  if (r.length <= 1 || t.length <= 1) throw Error("Source/target path must not be empty and point at root");
  if (0 === t.indexOf(r)) throw Error("Target path cannot be contained within source");
  var n = T(t);
  var o = e;

  var _iterator5 = _createForOfIteratorHelper(n),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _e = _step5.value;
      if (!ie(o)) return;
      o = o[_e];
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  if (!ie(o)) return;
  var i = T(r);
  var a = e;

  var _iterator6 = _createForOfIteratorHelper(i.entries()),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var _step6$value = _slicedToArray(_step6.value, 2),
          _e2 = _step6$value[0],
          _t3 = _step6$value[1];

      if (!ie(a) || _t3 in a) return;

      var _r5 = _e2 === i.length - 1 ? o : {};

      a[_t3] = _r5, a = _r5;
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  delete e[n[0]], function e(t, r, n) {
    for (var _i4 = 0, _Object$keys2 = Object.keys(t); _i4 < _Object$keys2.length; _i4++) {
      var _o4 = _Object$keys2[_i4];
      var _i5 = t[_o4];
      if ("$ref" !== _o4) ie(_i5) && e(_i5, r, n);else {
        if ("string" != typeof _i5 || !E(_i5)) continue;
        0 === _i5.indexOf(r) && (t[_o4] = _i5.replace(r, n));
      }
    }
  }(e, t, r);
}

function se(_x, _x2, _x3, _x4, _x5) {
  return _se.apply(this, arguments);
}

function _se() {
  _se = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e, t, r, n, o) {
    var i, u, l, f, p, h, _iterator7, _step7, _s2, _p2, _step7$value, _r8, _a2, _s;

    return _regeneratorRuntime().wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            i = function (e, t) {
              var r = R(t);
              return null === r ? e : a(r) ? r : s(c(e), r);
            }(t, r);

            u = G(r) || "#";
            _context2.next = 4;
            return e[i];

          case 4:
            l = _context2.sent;
            f = T(u);
            p = _toConsumableArray(f);
            h = {
              value: l
            };
            _iterator7 = _createForOfIteratorHelper(U(h, f, u));
            _context2.prev = 9;

            _iterator7.s();

          case 11:
            if ((_step7 = _iterator7.n()).done) {
              _context2.next = 22;
              break;
            }

            _step7$value = _slicedToArray(_step7.value, 2), _r8 = _step7$value[0], _a2 = _step7$value[1];

            if (!n.includes(_a2)) {
              _context2.next = 15;
              break;
            }

            return _context2.abrupt("return", {
              source: t,
              location: null != o ? o : p,
              value: n[n.length - 1]
            });

          case 15:
            n.push(_a2);
            _context2.next = 18;
            return se(e, i, _a2.$ref, n, p);

          case 18:
            _s = _context2.sent;
            (_s2 = _s, i = _s2.source, p = _s2.location, _s2), h.value = _s.value, (_p2 = p).push.apply(_p2, _toConsumableArray(f.slice(_r8 + 1)));

          case 20:
            _context2.next = 11;
            break;

          case 22:
            _context2.next = 27;
            break;

          case 24:
            _context2.prev = 24;
            _context2.t0 = _context2["catch"](9);

            _iterator7.e(_context2.t0);

          case 27:
            _context2.prev = 27;

            _iterator7.f();

            return _context2.finish(27);

          case 30:
            return _context2.abrupt("return", {
              source: i,
              location: p,
              value: n.length > 0 ? K(n[n.length - 1], h.value) : h.value
            });

          case 31:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee, null, [[9, 24, 27, 30]]);
  }));
  return _se.apply(this, arguments);
}

function ce(_x6, _x7, _x8) {
  return _ce.apply(this, arguments);
}

function _ce() {
  _ce = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e, t, r) {
    return _regeneratorRuntime().wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return ue(e, t, r);

          case 2:
            return _context3.abrupt("return", _context3.sent.value);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2);
  }));
  return _ce.apply(this, arguments);
}

function ue(e, t, r) {
  return se(e, t, r, []);
}

var le = function le(e, t) {
  if ("string" != typeof e) return e;

  try {
    var _r6 = fe(e);

    return "string" == typeof _r6 ? _r6 : JSON.parse(e, t);
  } catch (e) {
    return;
  }
},
    fe = function fe(e) {
  var t = Number(e);
  return Number.isFinite(t) ? String(t) === e ? t : e : NaN;
},
    pe = function pe(e, t, r) {
  if ("string" == typeof e) return e;

  try {
    return JSON.stringify(e, t, r);
  } catch (n) {
    return m(e, t, r);
  }
},
    he = function he(e, t) {
  if (e instanceof Array) {
    if (t instanceof Array) {
      if (t.length > e.length) return !1;

      for (var _r7 in t) {
        if (!t.hasOwnProperty(_r7)) continue;

        var _n5 = parseInt(e[_r7]),
            _o5 = parseInt(t[_r7]);

        if (isNaN(_n5) && isNaN(_o5)) {
          if (e[_r7] !== t[_r7]) return !1;
        } else if (_n5 !== _o5) return !1;
      }
    }
  } else {
    if ("string" != typeof e) return !1;
    if ("string" == typeof t) return e.startsWith(t);
  }

  return !0;
},
    ye = function ye(e, t, r) {
  var n = pe(e, t, r);
  if (void 0 === n) throw new Error("The value could not be stringified");
  return n;
};

function ge(e) {
  return e.replace(/^(\/|#\/)/, "").split("/").map(B).map(de).join(".");
}

function de(e) {
  return e.includes(".") ? "[\"".concat(e.replace(/"/g, '\\"'), "\"]") : e;
}

var ve = Symbol.for(d),
    me = {
  ownKeys: function ownKeys(e) {
    return ve in e ? e[ve] : Reflect.ownKeys(e);
  }
},
    be = function be(e) {
  return new Proxy(e, me);
};

function we(e, t) {
  if ("string" == typeof e && "string" == typeof t) return i(e, t);
  if (!(e && Array.isArray(e) && e.length && t && Array.isArray(t) && t.length)) return e;
  var r = 0;

  for (var _n6 in e) {
    if (e.hasOwnProperty(_n6)) {
      if (e[_n6] !== t[_n6]) break;
      r++;
    }
  }

  return e.slice(r);
}

export { V as BUNDLE_ROOT, F as ERRORS_ROOT, ve as KEYS, L as bundleTarget, P as decodePointer, B as decodePointerFragment, q as decycle, z as encodePointer, $ as encodePointerFragment, G as extractPointerFromRef, R as extractSourceFromRef, H as getFirstPrimitiveProperty, Q as getJsonPathForPosition, X as getLastPathSegment, Y as getLocationForJsonPath, A as hasRef, E as isLocalRef, b as isPlainObject, ee as parseTree, Z as parseWithPointers, x as pathToPointer, T as pointerToPath, oe as renameObjectKey, ae as reparentBundleTarget, ce as resolveExternalRef, ue as resolveExternalRefWithLocation, M as resolveInlineRef, C as resolveInlineRefWithLocation, le as safeParse, pe as safeStringify, he as startsWith, ye as stringify, ge as toPropertyPath, be as trapAccess, J as traverse, we as trimStart };